// extracted by mini-css-extract-plugin
export default {"topLeft":"src-layout-EditorPageLayout-GoBackAndBreadCrumb-css__topLeft--50nQP","button":"src-layout-EditorPageLayout-GoBackAndBreadCrumb-css__button---TqAL"};